import { gql } from "@apollo/client";












export const UPDATE_CRM_FORM = gql`
  mutation UpdateCrmForm($formId: Int!, $input: updateCrmFormInput) {
    updateCrmForm(formId: $formId, input: $input)
  }
`;




